module.exports = __webpack_public_path__ + "media/images/pic/teachers/katarzyna-lesniewska-5cdee2a48917705ed7691f42d8a8f1d9.webp";